
import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/UI/button/Button.vue';
import StopDrawing from '@/components/jobDetailed/StopDrawing/StopDrawing.vue';
import TableList from '@/components/UI/TableList.vue';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import LookupSuburb from '@/components/UI/lookups/LookupSuburb.vue';
import { AirRoadBookingStateData, AirRoadJobData } from '@/models/airRoad';
import { getSuburb } from '@/api';
import { getBaseName } from '@/utils/Common';

@Component({
  components: { LookupSuburb, DateTimezoneToggle, TableList, StopDrawing, Button },
})
export default class JobsTable extends Vue {
  @Prop(Boolean) loading!: boolean;
  @Prop(Number) tableOpenedJobIdx!: number;
  @Prop(Array) tableData!: Array<AirRoadJobData>;
  @Prop(Array) jobsToBook!: Array<AirRoadJobData>;
  @Prop(Object) jobsToBookOriginal!: AirRoadJobData;
  @Prop(Object) bookingState!: AirRoadBookingStateData;
  @Prop(Object) pagination!: Record<string, number | number[]>;

  public jobDefaultData: AirRoadJobData = {
    id: 0,
    rockhopper_id: 0,
    rockhopper_date: '',
    booked_at: '',
    reference_1: '',
    reference_2: '',
    reference_3: '',
    customer: '',
    status: 0,
    stops: [],
    products: [],
    error_message: '',
    booked_by: '',
    split_base: 0,
    priority: false,
    connote: '',
    labels: false,
    json_used_for_booking: null,
    exclude_leg: null,
    customer_code: '',
    error_text: '',
    special_options: [],
  };

  public get nextButtonText(): string {
    return this.bookingState.quickJobs ? 'Book the job' : 'Check delivery address';
  }

  public autocompleteSuburb = getSuburb;
  public getBaseName = getBaseName;

  backBtnClicked() {
    this.$emit('backBtnClicked');
  }

  closeAddressModal() {
    this.$emit('closeAddressModal');
  }

  updatePagination() {
    this.$emit('updatePagination');
  }

  nextStepClick() {
    this.$emit('nextStepClick');
  }

  tableJobRowClick(idx: number) {
    this.$emit('tableJobRowClick', idx);
  }

  // Row checkbox
  public jobCheckboxClicked(id) {
    const jobChosenIdx = this.bookingState.chosenJobs.findIndex(x => x === id);
    if (jobChosenIdx === -1) {
      this.bookingState.chosenJobs.push(id);
    } else {
      this.bookingState.chosenJobs.splice(jobChosenIdx, 1);
      if (this.bookingState.allChosen) {
        this.bookingState.allChosen = false;
      }
    }
  }
  // Checkbox all
  public jobCheckboxAllClicked() {
    const jobIds = this.tableData.reduce((acc: number[], obj) => {
      if (!obj.error_message) {
        acc.push(obj.rockhopper_id);
      }
      return acc;
    }, []);
    if (!this.bookingState.allChosen) {
      this.bookingState.chosenJobs = jobIds;
    } else {
      this.bookingState.chosenJobs.length = 0;
    }
  }
  // Row Radio
  public jobRadioClicked(id: number) {
    this.bookingState.singleJobChosen = { ...this.jobDefaultData };
    this.bookingState.singleJobChosen[id] = true;
    this.bookingState.chosenJobs = [];
    this.bookingState.chosenJobs.push(id);
  }
}
